/* Shared UI tokens that have no theme-palette equivalent.
 *
 * A lighter take on `palette.divider` (#D7D8DB): that value is tuned for
 * separating full-width sections, and at the density of nested cards it draws
 * harder than the content it frames. These are the design system's own line
 * colour and a dark-mode counterpart sitting the same distance from its
 * background. Opaque, so a border never picks up whatever is behind it.
 */
export const SOFT_BORDER_LIGHT = '#e6ebf1';
export const SOFT_BORDER_DARK = '#31373f';

/* The AI-credit accent. Distinct from the gold coin on purpose: AI credits are
 * a separate currency, and a user reading a price needs to see which wallet it
 * comes out of before they read the number. Same pair everywhere an AI price or
 * balance is shown -- the job-fit pills, the builder top bar, the enhance panel.
 */
export const AI_PILL_BG = '#f2ecfe';
export const AI_PILL_TEXT = '#46209b';
export const AI_PILL_BG_DARK = '#241a4a';
/** Hairline for violet AI-credit surfaces that sit on white -- the pills have
 * no border, but the balance card in the design does. */
export const AI_PILL_BORDER = '#e0d2fb';
export const AI_PILL_BORDER_DARK = '#3a2d63';
export const AI_PILL_TEXT_DARK = '#c9b8ff';

/* The applicant app's navy chrome: the mobile bottom bar, and the mobile top
 * bar that mirrors it. Top/bottom stops of one gradient. */
export const BRAND_NAVY_LIGHT = '#16375a';
export const BRAND_NAVY_DEEP = '#0f2740';
